import { render, staticRenderFns } from "./propertyAreaUnitListing.vue?vue&type=template&id=3fb72e98&"
import script from "./propertyAreaUnitListing.vue?vue&type=script&lang=js&"
export * from "./propertyAreaUnitListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports